module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro-4e498e5cbeec5471b6f5340d9186bd60.webp";